import Vue from 'vue';
import datePicker from '@alireza-ab/vue-persian-datepicker'
Vue.component('date-picker', datePicker)